import React from 'react';
import PropTypes from 'prop-types';
import Number from '../../Number';
import Unit from '../../Unit';

AuctionHeaderEnergyPerLot.propTypes = {
    energyPerLot: PropTypes.number.isRequired,
    unit: PropTypes.string.isRequired,
    postfix: PropTypes.node,
};

function AuctionHeaderEnergyPerLot(props) {
    const {
        energyPerLot,
        unit,
        postfix = null,
    } = props;
    return (
        <div className="auction-header--energy-per-lot">
            <Number value={energyPerLot} /><Unit unit={unit} />{postfix && <>&nbsp;{postfix}</>}
        </div>
    );
}

export default AuctionHeaderEnergyPerLot;
